// removed by extract-text-webpack-plugin
module.exports = {"item-card-control":"item-card-control___1_FCI","button":"button___1OsF4","live":"live___u0R1_","help-button":"help-button___2NZND","retract":"retract___1ckjE","why-cant-i-retract-bid-popover-text":"why-cant-i-retract-bid-popover-text___1ffuS","why_cant_i_retract_bid_popover_text":"why_cant_i_retract_bid_popover_text___n73IJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/CardCta.scss
// module id = O+2Z
// module chunks = 57